import { render, staticRenderFns } from "./transfersTable.vue?vue&type=template&id=670921fa&scoped=true"
import script from "./transfersTable.vue?vue&type=script&lang=js"
export * from "./transfersTable.vue?vue&type=script&lang=js"
import style0 from "./transfersTable.vue?vue&type=style&index=0&id=670921fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670921fa",
  null
  
)

export default component.exports